import { Box, Button, Grid, LinearProgress } from "@material-ui/core";
// import { lighten, makeStyles, withStyles } from "@material-ui/core/styles";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { DateRange } from "@mui/lab/DateRangePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import MobileDateRangePicker from "@mui/lab/MobileDateRangePicker";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { TransitionProps } from "@mui/material/transitions";

import axios from "axios";
import jaLocale from "date-fns/locale/ja";
// import moment from "moment";
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import { API_URL } from "../../Const";
import GenericTemplate from "../templates/GenericTemplate";
import "./style.css";
import { useLoadingOverlay } from "../../utilHooks/loadingOverlay";

//  form modules
import { yupResolver } from "@hookform/resolvers/yup";
import { SubmitHandler, useForm } from "react-hook-form";
import * as yup from "yup";

/* 型定義 フォーム送信用の型 */
interface ConstructionSubmitFormType {
  construction_name: string;
  contractor: string;
  user_name: string;
  orderer: string;
  overview: string;
  startDate: string;
  endDate: string;
}

/* yup schema  */
const ConstructionSchema = yup.object({
  construction_name: yup
    .string()
    .required("必須項目です")
    .max(25, "25文字以内で入力してください。"),
  user_name: yup
    .string()
    .required("必須項目です")
    .max(25, "25文字以内で入力してください。"),
  orderer: yup
    .string()
    .required("必須項目です")
    .max(25, "25文字以内で入力してください。"),
  overview: yup
    .string()
    .required("必須項目です")
    .max(200, "200文字以下で入力してください。"),
  startDate: yup.string().required("必須項目です。"),
  endDate: yup.string().required("必須項目です。"),
});

/* ダイアログ関連*/
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/* ダイアログ関連*/

/* React Component */
const InspectionlistEdit: React.FC = () => {
  const { openLoading, closeLoading } = useLoadingOverlay();

  /*スピナー処理*/
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  /* dateRange用のuseState */
  const [dateValue, setDateValue] = React.useState<DateRange<Date>>([
    null,
    null,
  ]);

  /*ダイアログ処理*/
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  /*id取得*/
  const { state } = useLocation();
  const conid = (state as any)?.conid;
  // console.log(conid)

  let jsonlist = JSON.parse(localStorage.getItem("datalist") || "{}");
  /* 出力確認
      console.log(jsonlist.token.IdToken)
      console.log(jsonlist.user.company_id)
      console.log(jsonlist.user.dealer_info_id)
    */

  /* 編集対象データをidに紐づけて抽出する。 */
  useEffect(() => {
    openLoading();
    axios
      .post(
        API_URL.CONSTRUCTION_GET,
        {
          construction_id: conid,
          company_id: jsonlist.user.company_id,
          dealer_info_id: jsonlist.user.dealer_info_id,
        },
        { headers: { Authorization: jsonlist.token.IdToken } }
      )
      .then((res) => {
        /* axios postで抽出した工事情報をformのデフォルト値にセットする。*/
        const fetchedData = res.data.data;
        /*　抽出できたデータの中身を確認。 console.log(fetchedData);*/
        setValue("construction_name", fetchedData.construction_name);
        setValue("orderer", fetchedData.orderer);
        setValue("user_name", fetchedData.user_name);
        setValue("contractor", fetchedData.contractor);
        setValue("overview", fetchedData.overview);
        setValue("startDate", fetchedData.start_date);
        setValue("endDate", fetchedData.end_date);
        setDateValue([fetchedData.start_date, fetchedData.end_date])

      })
      .catch((error) => {
        //let jsonObject = JSON.parse(error);
        console.log(error);
      })
      .finally(() => {
        closeLoading();
      });
  }, []);

  // react-hook-formとyupを紐づける。
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<ConstructionSubmitFormType>({
    resolver: yupResolver(ConstructionSchema),
  });

  /* Submitに成功した時の挙動を記述する。 */
  const onSubmit: SubmitHandler<ConstructionSubmitFormType> = (data) => {

    /* バリデーションを通過し、送信されたデータを確認する。*/
    console.log(data);

    /*スピナー*/
    if (!loading) {
      setSuccess(false);
      setLoading(true);
    }
    /*スピナー*/

    openLoading();
    axios
      .post(
        API_URL.CONSTRUCTION_UPDATE,
        {
          /* サンプル postテキスト
         "construction_id": "dokodemokun_6481545d_f759_4460_8b63_257e2179cf4f",
         "dealer_info_id": "sampleCompany1",
         "company_id":"sampleCompany1",
         "company_name":"新岡商会",
         "construction_name":"工事名123更新後",
         "address":"工事名2住所変更後です更新後",
         "user_name":"請負者名更新後s",
         "contractor": "契約者？更新後",
         "orderer":"発注者項目テスト",
         "start_date":"1644332400000",
         "end_date":"164　4937200000",
         "overview":"工事の概要入力欄です。更新後",
         "login_user": "t-niioka2@datt.co.jp"
         */
          construction_id: conid,
          dealer_info_id: jsonlist.user.dealer_info_id,
          company_id: jsonlist.user.company_id,
          company_name: jsonlist.company.company_name,
          construction_name: data.construction_name,
          // address: data.address,
          user_name: data.user_name,
          contractor: data.contractor,
          orderer: data.orderer,
          start_date: data.startDate,
          end_date: data.endDate,
          overview: data.overview,
          login_user: jsonlist.user.user_id,
        },
        { headers: { Authorization: jsonlist.token.IdToken } }
      )
      .then((res) => {
        setSuccess(true);
        setLoading(false);
        handleClickOpen();
        console.log(res);
      })
      .catch((error) => {
        setSuccess(true);
        setLoading(false);
        console.log(error);
      })
      .finally(() => {
        closeLoading();
      });
  };

  /* React Component 中身 */
  return (
    <GenericTemplate title="工事編集">
      <div>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ color: "#0d47a1" }}>
            {"更新が完了しました"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description"></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              style={{ color: "#fff", backgroundColor: "#1e88e5" }}
              component={Link}
              to={{ pathname: "/Inspectionlist", state: { conid: conid } }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <Stack spacing={3} margin={2}></Stack>

      <Grid container spacing={0} justifyContent="center">
        <Grid item xs={1} className="detail-title">
          工事名
        </Grid>
        <Grid item xs={11}>
          <TextField
            {...register("construction_name")}
            error={"construction_name" in errors}
            helperText={errors.construction_name?.message}
          />
        </Grid>
      </Grid>

      <Stack spacing={1} margin={2}></Stack>

      <Grid container spacing={0} justifyContent="center">
        <Grid item xs={1} className="detail-title">
          請負者
        </Grid>
        <Grid item xs={11}>
          <TextField
            {...register("user_name")}
            error={"user_name" in errors}
            helperText={errors.user_name?.message}
          />
        </Grid>
      </Grid>

      <Stack spacing={1} margin={2}></Stack>

      <Grid container spacing={0} justifyContent="center">
        <Grid item xs={1} className="detail-title">
          発注者
        </Grid>
        <Grid item xs={11}>
          <TextField
            {...register("orderer")}
            error={"orderer" in errors}
            helperText={errors.orderer?.message}
          />
        </Grid>
      </Grid>

      <Stack spacing={1} margin={2}></Stack>

      <Grid container spacing={0} justifyContent="center">
        <Grid item xs={1} className="detail-title">
          概要
        </Grid>
        <Grid item xs={11}>
          <TextField
            id="outlined-basic"
            variant="outlined"
            className="InsText4"
            multiline={true}
            rows={3}
            {...register("overview")}
            error={"overview" in errors}
            helperText={errors.overview?.message}
          />
        </Grid>
      </Grid>

      <Stack spacing={1} margin={2}></Stack>

      <Grid container spacing={0} justifyContent="center">
        <Grid item xs={1} className="detail-title">
          工期
        </Grid>
        <Grid item xs={11}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={jaLocale}>
            <MobileDateRangePicker
              startText={"開始時期"}
              endText="終了時期"
              value={dateValue}
              onChange={(a) => {
                setDateValue(a);
              }}
              renderInput={(startProps, endProps) => (
                <React.Fragment>
                  <TextField
                    /* フォームラベルの上にデフォルトの値が上乗せされるのを防ぐ。 */
                    InputLabelProps={{ shrink: true }}
                    {...startProps}
                    /* RHFのフォームに接続する。*/
                    {...register("startDate")}
                    /* errorテキストの表示。*/
                    error={"startDate" in errors}
                    helperText={errors.startDate?.message}
                  />

                  <Box sx={{ mx: 2 }}> 〜 </Box>

                  <TextField
                    /* フォームラベルの上にデフォルトの値が上乗せされるのを防ぐ。 */
                    InputLabelProps={{ shrink: true }}
                    {...endProps}
                    /* RHFのフォームに接続する。*/
                    {...register("endDate")}
                    error={"endDate" in errors}
                    /* errorテキストの表示。*/
                    helperText={errors.endDate?.message}
                  />
                </React.Fragment>
              )}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>

      <Stack spacing={2} margin={1}></Stack>

      <Grid container spacing={0}>
        <Grid item xs={2}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box sx={{ m: 1, position: "relative" }}>
              <Button
                color="primary"
                variant="contained"
                disabled={loading}
                size="large"
                onClick={handleSubmit(onSubmit)}
              >
                更新
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: green[500],
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                  }}
                />
              )}
            </Box>
          </Box>
        </Grid>

        <Grid item xs={2}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box sx={{ m: 1, position: "relative" }}>
              <Button
                className="btnlink"
                color="primary"
                variant="contained"
                size="large"
                component={Link}
                to={{ pathname: "/Inspectionlist", state: { conid: conid } }}
              >
                キャンセル
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </GenericTemplate>
  );
};

export default InspectionlistEdit;